import {useIntl} from 'react-intl';
import koMsg from '../lang/ko.json';

/**
 * 메시지 포맷팅 훅
 * @param text - 포맷팅할 텍스트
 * @returns 포맷팅된 메시지 또는 undefined
 * @public
 */
export const useFormatMsg = (text: string | undefined) => {
  const intl = useIntl();
  try {
    if (!text) {
      return '';
    }
    const defaultMessage = Object.entries(koMsg).filter(
      word => word[0] === text,
    );
    return intl.formatMessage({
      id: text,
      defaultMessage: defaultMessage[0][1],
    });
  } catch (e: any) {
    return undefined;
  }
};

/**
 * 메시지 배열 포맷팅 훅
 * @param textArray - 포맷팅할 텍스트 배열
 * @returns 포맷팅된 메시지 객체
 * @public
 */
export const useFormatMsgArray = (textArray: string[]) => {
  const intl = useIntl();
  interface IResult {
    [id: string]: string;
  }
  let result: IResult = {};
  textArray.map((element: string) => {
    result[element] = intl.formatMessage({
      id: element,
      defaultMessage: Object.entries(koMsg).filter(
        word => word[0] === element,
      )[0][1],
    });
  });
  return result;
};
